ui-cms-link {
  display: flex;

  &[alignment='right'] {
    @include breakpoint($medium) {
      sd-button,
      sd-link {
        margin-left: auto;
      }
    }
  }

  &[alignment='center'] {
    sd-button,
    sd-link {
      margin: 0 auto;
    }
  }

  sd-button::part(icon-left),
  sd-button::part(icon-right) {
    flex: none;
  }

  @include breakpoint($xsmallOnly) {
    sd-button {
      width: 100%;
    }
  }

  .sr-only {
    @include sr-only;
  }
}
